module.exports = __webpack_public_path__ + "static/media/logo2.a3bc79ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2.png
// module id = 2620
// module chunks = 0